import { render, staticRenderFns } from "./Division.vue?vue&type=template&id=83af21b8&scoped=true&"
import script from "./Division.vue?vue&type=script&lang=js&"
export * from "./Division.vue?vue&type=script&lang=js&"
import style0 from "./Division.vue?vue&type=style&index=0&id=83af21b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83af21b8",
  null
  
)

export default component.exports